import React from 'react'
import { useWindowDimensions, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useCopilot } from 'react-native-copilot'
import { StyleService, useStyleSheet } from '@style/service'
import { getAnchoredStepByTargetId, getStepIndexById } from './steps'
import { NoraHomePageControl } from './NoraHomePageControl'
import { NoraHomeWalkthroughCloseButton } from './NoraHomeWalkthroughCloseButton'
import { useNoraHomeWalkthroughContext } from './NoraHomeWalkthroughContext'
import { getNoraHomeWalkthroughLayout } from './NoraHomeWalkthroughLayout'

export const NoraHomeCopilotControls = () => {
  const styles = useStyleSheet(themedStyles)
  const insets = useSafeAreaInsets()
  const windowDimensions = useWindowDimensions()
  const { currentStep, stop } = useCopilot()
  const context = useNoraHomeWalkthroughContext()
  const step = currentStep ? getAnchoredStepByTargetId(currentStep.name) : undefined

  if (!context || !step) {
    return null
  }

  const layout = getNoraHomeWalkthroughLayout(windowDimensions)

  return (
    <View
      style={styles.controls}
      testID="nora-home-walkthrough-copilot-controls"
      pointerEvents="box-none"
    >
      <NoraHomeWalkthroughCloseButton
        testID="nora-home-walkthrough-copilot-close"
        onPress={() => void stop()}
      />
      <View
        style={[
          styles.pageControl,
          {
            bottom: insets.bottom + layout.pageControlBottom,
            width: windowDimensions.width,
          },
        ]}
        testID="nora-home-walkthrough-anchored-page-control"
        pointerEvents="none"
      >
        <NoraHomePageControl stepIndex={getStepIndexById(step.id)} isOverlay />
      </View>
    </View>
  )
}

const themedStyles = StyleService.create({
  controls: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  pageControl: {
    alignItems: 'center',
    left: 0,
    position: 'absolute',
  },
})
